<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup>
// Nu mai avem nevoie de ref, isLoggedIn sau importuri aici!
// App.vue devine "dumb" (simplu).
</script>

<style>
/* Stilurile globale rămân la fel */
body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  /* Am scos margin-top: 60px; pentru a permite un control mai bun pe pagină */
}
#app {
  /* Am scos max-width și margin: 0 auto;
    Vom aplica aceste stiluri pe PAGINI (cum ar fi Auth.vue), 
    nu pe întreaga aplicație, pentru a permite panourilor
    de admin să folosească toată lățimea dacă e nevoie.
  */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>